import { createSelector } from "reselect";

import {
  getTripsCities,
  getTripsLocations,
  getTripsSegments
} from "@app/modules/results/selectors/state-accessors";
import type { ResultsReduxState } from "@app/types/results-redux-types";

export const getTripSegmentLocationName = createSelector(
  [
    getTripsSegments,
    getTripsLocations,
    getTripsCities,
    (_state: ResultsReduxState, segment_id: string) => segment_id
  ],
  (tripsSegments, tripsLocations, tripsCities, segment_id) => {
    const segment = tripsSegments[segment_id];
    // @ts-expect-error TS2339 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const { origin_id, destination_id } = segment;
    const originLocation = tripsLocations[origin_id];
    const destinationLocation = tripsLocations[destination_id];

    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const origin_name = originLocation.city_id
      ? // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        tripsCities[originLocation.city_id].name
      : "";
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const destination_name = destinationLocation.city_id
      ? // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        tripsCities[destinationLocation.city_id].name
      : "";

    return {
      origin_name,
      destination_name
    };
  }
);
